<!-- 图书柜-公共内容模板 -->
<template>
  <div class="Bookcase" @click="dblBtn">
    <!-- 广告位 -->
    <Ads class="ad"></Ads>
    <div class="mainArea">
      <router-view/>
    </div>
    <!-- 客服 -->
    <div class="Airlines" @click="goAirlines" v-show="$route.name !== 'BookcaseAirlines'">客服</div>
    <div class="configBtn" v-show="showBtn == true" @click.stop>
      <el-button type="info" @click="toConfig">修改配置</el-button>
    </div>
    <!-- 无操作倒计时 -->
    <!-- <CountDown ref="CountDown" class="CountDown" v-if="!notNoOp"></CountDown> -->
    <div class="CountDown" v-if="!notNoOp">
      {{Time}}
    </div>
  </div>
</template>

<script>
import CountDown from '@/components/Bookcase/Common/CountDown' // 倒计时
import Ads from '@/assets/ads'   // 广告
import * as config from '../../../static/js/config.js'
import { messageError } from '../../../static/js/utils/utility'
import { ECMallApi } from '../../../static/Bookcase/js/api'
let vm, interval= '', defaulTime = 120

export default {
  name:'Bookcase',
  components: {
    CountDown,
    Ads
  },
  data() {
    return {
      num: 0, // 点击次数
      time: '', 
      showBtn: false,

      notNoOp: this.$route.meta.notNoOp,
      Time: defaulTime
    }
  },
  created() {
    vm = this
    // console.log('route', vm.$route)
  },
  mounted () {
    if (!vm.notNoOp) { vm.defalutCountDown() }
  },
  methods: {
    // email 发送报警提醒
    async noticeEmail () {
      if ( !vm.$store.state.ECMall_warningData.user_id ) {
        return
      }
      console.log('准备发送预警', '')
      let data = vm.$store.state.ECMall_warningData
      data.cabinet_id = config.deviceId

      let res = await ECMallApi.noticeEmail(data)
      vm.$store.state.ECMall_warningData = {}
      if (res.meta.code === 200) {
        console.log('预警发送成功', '')
      }  else {
        messageError('预警发送失败')
      }
    },
    // 去客服中心
    goAirlines () {
      vm.$router.push('/Bookcase/Airlines')
    },
    // 跳转到配置页
    toConfig() {
      this.$router.push({
        path: '/CConfigSetting',
        query: {
          'project': true,
        }
      })
    },
    // 用户操作平板，重新计时
    reclock () {
      if (!vm.notNoOp) {
        // console.log('重新计时', '')
        vm.Time = defaulTime
        // vm.$refs.CountDown.Time =  vm.$refs.CountDown.time
      }
    },
    // 连续点击屏幕5次
    dblBtn() {
      vm.reclock()
      if (vm.$route.path !== '/Bookcase/Index') {return}
      var that = this;
      this.num++
      if(this.num == 1) {
        that.timer1 = new Date().getTime()/1000
      }
      if(this.num == 5) {
        this.timer4= new Date().getTime()/1000
        if(that.timer4 - that.timer1 <= 2) {
          that.num = 0
          that.showBtn = true
          setTimeout(function() {
            that.showBtn = false
          }, 5000);
        } else {
          this.num = 0
        }
      }
    },
    /** 倒计时 */
    countDown(func) {
      interval = window.setInterval(function () {
        func()
      }, 1000)
    },
    clearCountDown () {
      clearInterval(interval)
      interval = ''
      // console.log('清除成功', '')
    },
    // 默认倒计时
    defalutCountDown () {
      vm.countDown(function () {
        vm.Time--
        console.log('vm.Time', vm.Time)
        // console.log(vm.Time < 0)
        if (vm.Time <= 0) {
          vm.clearCountDown()
          vm.cancelBack()
        }
      })
    },
    // 返回首页
    cancelBack: function () {
      // return
      vm.$store.state.type = ''
      vm.$store.state.eUserInfo = ''
      vm.$store.state.ECMall_activeGoods = {}
      vm.$store.state.ECMall_timeEnd = !(vm.$store.state.ECMall_timeEnd)
      vm.$router.push({
        // 你要跳转的地址
        path: '/Bookcase/Index'
      })
    }
  },
  watch: {
    '$route' (newVal, oldVal) {
      // console.log('tag', newVal)
      // console.log('notNoOp', newVal.meta.notNoOp)
      let newNotNoOp = newVal.meta.notNoOp
      let oldNotNoOp = oldVal.meta.notNoOp
      console.log('newNotNoOp::', newNotNoOp, 'oldNotNoOp::', oldNotNoOp)
      vm.notNoOp = newNotNoOp
      // 清除倒计时
      if (newNotNoOp && !oldNotNoOp) { 
        vm.clearCountDown()
      }
      // 开始倒计时
      if (!newNotNoOp && oldNotNoOp) {
        vm.defalutCountDown()
      }
    },
    // 变化就发送预警
    '$store.state.ECMall_timeEnd' (newVal) {
      console.log('ECMall_timeEnd', vm.$store.state.ECMall_timeEnd)
      vm.noticeEmail()
    }
  },
}
</script>

<style lang="less">
.CountDown{
  opacity: 0; 
  // font-size: 0.6rem;
  // line-height: 1em;
  // color: #666;
  // font-weight: bold;
  // position: fixed;
  // left: 0;
  // top: 0;
  // z-index: 9999;
}
  .Bookcase {
    width: 100%;
    height: 100vh;
    color: #333333;
    background-color: #647de6;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    .ad {
      flex-shrink: 0;
      width: 100%;
      height: 4rem;
      // background: url(/static/Bookcase/images/ad.png) center no-repeat;
      // background-size: 100% 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .mainArea {
      width: 100%;
      height: calc(100vh - 4rem);
      padding: 0.25rem;
    }
    // 客服样式
    .Airlines {
      width: 2rem;
      height: 0.9rem;
      text-indent: 1.07rem;
      font-size: 0.32rem;
      line-height: 0.9rem;
      font-weight: bold;
      letter-spacing: 0.02rem;
      border-top-left-radius: 0.9rem;
      border-bottom-left-radius: 0.9rem;
      background: url(/static/Bookcase/images/icon_Airlines.png) 0.52rem center no-repeat #f3ae3e;
      background-size: 0.45rem 0.41rem;
      color: #fcfcfc;
      position: fixed;
      right: 0;
      bottom: 2.76rem;
    }
    // 导航栏样式
    .BookcaseNavBar {
      width: 100%;
      height: 1.2rem;
      line-height: 1.2rem;
      padding: 0 0.6rem 0 0.5rem;
      font-weight: bold;
      background-color: #ffffff;
      box-shadow: 0 -0.02rem 0.24rem rgba(0, 0, 0, 0.21);
      display: flex;
      align-items: center;
      // justify-content: space-between;
      &.flexEnd {
        justify-content: flex-end;
      }
      span {
        display: block;
      }
      .back {
        flex-shrink: 0;
        width: 0.45rem;
        height: 100%;
        padding: 0 0.1rem;
        margin-right: 1rem;
        background: url(/static/Bookcase/images/icon_back.png) center no-repeat;
        background-size: 0.25rem 0.41rem;
      }
      .title {
        flex-shrink: 0;
        width: 6.54rem;
        font-size: 0.4rem;
        text-align: center;
      }
      .logout {
        flex-shrink: 0;
        width: 1.28rem;
        font-size: 0.32rem;
        color: #666666;
      }
    }
    // 按钮样式
    .bbtn {
      height: 1.26rem;
      line-height: 1.26rem;
      border-radius: 1.26rem;
      box-sizing: border-box;
      border: 0.01rem solid transparent;
      text-align: center;
      color: #fff;
      &.mini {
        height: 0.56rem;
        line-height: 0.56rem;
      }
      &.bbtn-default {
        border-color: #647de6;
        color: #647de6;
      }
      &.bbtn-p {
        background-color: #647de6;
      }
      &.bbtn-y {
        background-color: #f3ae3e;
      }
      &.bbtn-r {
        background-color: #e26457;
      }
    }
    // 无内容区样式
    .noReserve {
      width: 5.8rem;
      height: 100%;
      margin: 4.2rem auto 0;
      text-align: center;
      display: flex;
      justify-content: center;
      .text {
        color: #b5b4b4;
        font-size: 0.48rem;
        line-height: 0.7rem;
        padding-top: 2.1rem;
        background: url(/static/Bookcase/images/icon_noReserve.png) top center no-repeat;
        background-size: 1.53rem 1.63rem;
      }
      &.two {
        margin-top: 3.2rem;
        .text {
          padding-top: 1.8rem;
          background: url(/static/Bookcase/images/icon_noReserve2.png) top center no-repeat;
          background-size: 1.52rem 1.36rem;
        }
      }
    }
    // 成功提示
    .successBox {
      width: 100%;
      height: 100%;
      margin: auto 0;
      text-align: center;
      background-color: #ffffff;
      box-shadow: 0 0.02rem 0.24rem rgba(0, 0, 0, 0.21);
      display: flex;
      flex-direction: column;
      align-items: center;
      .text {
        margin-top: 2.31rem;
        font-weight: bold;
        font-size: 0.48rem;
        color: #666666;
        padding-top: 2.82rem;
        background: url(/static/Bookcase/images/icon_success.png) top center no-repeat;
        background-size: 2.22rem 2.22rem;
      }
      .pText {
        margin-top: 0.45rem;
        font-size: 0.36rem;
        line-height: 0.5rem;
        color: #999999;
        &.color {
          color: #647de6;
        }
      }
      .bbtn-continue {
        width: 3.78rem;
        margin-top: 0.93rem;
        height: 0.87rem;
        line-height: 0.87rem;
        font-size: 0.38rem;
        font-weight: bold;
        box-sizing: border-box;
        color: #647de6;
        border: 0.03rem solid #647de6;
      }
    }

    .configBtn {
      position: absolute;
      right: 0.94rem;
      top: 0.47rem;
      z-index: 99;
      .el-button {
        height: 0.94rem;
        // width: 2.54rem;
        padding: 0 0.6rem;
        font-size: 0.4rem;
        color: #fff;
        font-weight: bold;
        border: none;
        border-radius: 0.12rem;
        line-height: 0.94rem;
        background: linear-gradient(#4aaafe, #0769be);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Bookcase/Bookcase.vue